import LoginButtonTemplate from "./LoginButtonTemplate";
import useGoogleLogin from "hooks/useGoogleLogin";
import useMixpanelWeb from "hooks/useMixpanelWeb";
import { useRecoilValue } from "recoil";
import { userAtom } from "recoil/userAtom";
import useGoogleLoginCoach from "../../hooks/useGoogleLoginCoach";

export default function GoogleLoginButtonCoach({
  render,
  onNotCoach,
}: {
  render?: (props: {
    onClick: (e?: any) => void;
    disabled?: boolean;
  }) => JSX.Element;
  onNotCoach?: () => void;
}) {
  const handleGoogleLogin = useGoogleLoginCoach(onNotCoach);
  const user = useRecoilValue(userAtom);

  const setMixPanel = useMixpanelWeb({
    eventName: "구글 로그인",
  });

  return (
    <LoginButtonTemplate
      loginType="google"
      action={() => {
        setMixPanel();
        handleGoogleLogin();
      }}
      isLoggedIn={!!user?.accessToken}
      widthPx={320}
      heightPx={54}
    />
  );
}
